export default "__VITE_ASSET__CbJxQzDz__"